<template>
  <div id="Career">

    <page-hero headerText=message.hero.careerHeader subText=message.hero.careerSub></page-hero>

    <!-- PAGE SELECTOR -->
    <div class="row mb-6 mb-lg-7 page-selector justify-content-center">
      <div class="col-4 col-sm-3 col-md-2 text-center" :class="{'is-active': isActiveTab(0)}"><a class="clickable text-blue-lato" @click="activeTab = 0">{{ $t('message.career.consultant') }}</a></div>
      <div class="col-4 col-sm-3 col-md-2 text-center" :class="{'is-active': isActiveTab(1)}"><a class="clickable text-blue-lato" @click="activeTab = 1">{{ $t('message.career.student') }}</a></div>
    </div>

    <!--.......................-->
    <!-- CONSULTANT PAGE START -->
    <!--.......................-->
    <div v-if="isActiveTab(0)">
      <!-- first section -->
      <h4 class="text-center mb-6 mb-lg-7 light-grey-text">{{ $t('message.careerCon.why') }}</h4>
      <div class="row justify-content-center text-center mx-auto mb-5 mb-lg-7">

        <div class="col-10 col-sm-5 col-md-4 col-lg-3 card border-0">
          <div class="icon-container icon-smaller">
            <img class="my-auto" src='/static/images/illustration/gemenskap.svg'>
          </div>

          <div class="card-body">
            <div class="text-blue-lato">{{ $t('message.careerCon.answer1') }}</div>
            <p class="card-text">{{ $t('message.careerCon.answer1txt') }}</p>
          </div>
        </div>

        <div class="col-10 col-sm-5 col-md-4 col-lg-3  card border-0">
          <div class="icon-container">
            <img src='/static/images/illustration/uppdrag.svg'>
          </div>

          <div class="card-body">
            <div class="text-blue-lato">{{ $t('message.careerCon.answer2') }}</div>
            <p class="card-text">{{ $t('message.careerCon.answer2txt') }}</p>
          </div>
        </div>

        <div class="w-100 mb-3 mb-sm-5"></div>

        <div class="col-10 col-sm-5 col-md-4 col-lg-3 card border-0">
          <div class="icon-container">
            <img src='/static/images/illustration/bygger.svg'>
          </div>

          <div class="card-body">
            <div class="text-blue-lato">{{ $t('message.careerCon.answer3') }}</div>
            <p class="card-text">{{ $t('message.careerCon.answer3txt') }}</p>
          </div>
        </div>

        <div class="col-10 col-sm-5 col-md-4 col-lg-3 card border-0">
          <div class="icon-container">
            <img src='/static/images/illustration/trygghet.svg'>
          </div>

          <div class="card-body">
            <div class="text-blue-lato">{{ $t('message.careerCon.answer4') }}</div>
            <p class="card-text">{{ $t('message.careerCon.answer4txt') }}</p>
          </div>
        </div>

      </div>

      <!-- Blue background section -->
      <div class="slanted-container-left ">
        <div class="col-5" id="moon">
          <img src="/static/images/planets/moon.svg" />
        </div>
      </div>

      <div class="row blue-background justify-content-center pt-7 pt-md-8 pb-7">
        <div class="col-10 col-sm-8 col-md-6 col-xl-5">
          <h3 class="font-weight-light ">{{ $t('message.careerCon.work') }}</h3>
          <p>{{ $t('message.careerCon.work1txt') }}</p>
          <p>{{ $t('message.careerCon.work2txt') }}</p>
          <p>{{ $t('message.careerCon.work3txt') }}<b>{{ $t('message.careerCon.techniques') }}</b></p>
        </div>
         <!--<div class="col-2 col-md-3 my-auto d-none d-md-block">
          <img class="astronaut-icon" src='/static/images/astronaut/knowledge.svg'>
        </div>-->
      </div>

      <div class="slanted-container-right mb-6 mb-lg-7"></div>

      <!-- third section -->
      <div class="row justify-content-center mb-5 mb-lg-7">
        <div class="col-10 col-sm-8 col-md-6 col-xl-5">
          <h3>{{ $t('message.careerCon.what') }}</h3>
          <p>{{ $t('message.careerCon.what1txt') }}</p>
          <p>{{ $t('message.careerCon.what2txt') }}</p>
        </div>
      </div>
      <!-- fourth section - Simon interview -->
      <div class="row justify-content-center mb-5 mb-lg-7 mx-auto">
        <div class="my-auto">
          <img class="rounded-image-responsive"  src='/static/images/simon.jpg'>
        </div>

        <div class="col-10 col-sm-8 col-md-6 col-lg-5 col-xl-4 mt-4 pl-md-5 pl-lg-6">
          <h3>{{ $t('message.careerCon.meet') }}</h3>
          <div class="text-blue-lato">{{ $t('message.careerCon.meet1question') }}</div><p>{{ $t('message.careerCon.meet1txt') }}</p>
          <div class="text-blue-lato">{{ $t('message.careerCon.meet2question') }}</div><p>{{ $t('message.careerCon.meet2txt') }}</p>
         <div class="text-blue-lato">{{ $t('message.careerCon.meet3question') }}</div><p>{{ $t('message.careerCon.meet3txt') }}</p>
        </div>
      </div>

      <!-- Siri interview -->
       <div class="row justify-content-center mb-5 mb-lg-7 align-items-center">
        <div class="col-10 col-sm-8 col-md-6 col-lg-5 col-xl-4 mt-4 pr-md-5 pr-lg-6 order-2 order-sm-1">
          <h3>{{ $t('message.careerCon.meetSiri') }}</h3>
          <div class="text-blue-lato">{{ $t('message.careerCon.meet1question') }}</div><p>{{ $t('message.careerCon.meetSiri1answer') }}</p>
          <div class="text-blue-lato">{{ $t('message.careerCon.meet2question') }}</div><p>{{ $t('message.careerCon.meetSiri2answer') }}</p>
          <div class="text-blue-lato">{{ $t('message.careerCon.meet4question') }}</div><p>{{ $t('message.careerCon.meetSiri4answer') }}</p>
        </div>
         <div class="my-auto order-1 order-sm-2">
          <img class="rounded-image-responsive" src='/static/images/siri.jpg'>
        </div>
      </div>

      <!-- Blue backround section 2 -->

      <div class="slanted-container-left "/>

      <div class="row blue-background justify-content-center py-5 py-md-7">
        <div class="col-10 col-sm-8 col-md-6 col-xl-5">
          <h3 class="font-weight-light">{{ $t('message.careerCon.perspective') }}</h3>
          <p>{{ $t('message.careerCon.perspective1txt') }}</p>
          <p>{{ $t('message.careerCon.perspective2txt') }}</p>
        </div>
      </div>

       <div class="slanted-container-right mb-6 mb-lg-7"/>

      <!-- CONTACT US SECTION-->

      <div class="row justify-content-center mb-8 mb-lg-7">
        <div class="col-9 col-sm-7 col-md-4 col-xl-3 text-center">
          <h3>{{ $t('message.careerCon.contactUs') }}</h3>
          <p>{{ $t('message.careerCon.contactUsTxt') }}</p>
          <div class="cta-button-container mx-auto">
            <router-link to="Contact">
              <div class="cta-button">{{ $t('message.button.contact') }}</div>
            </router-link>
          </div>
        </div>
      </div>


      <!-- picture -->
      <div class="row photo-section-consultant"/>

    </div>
    <!--.....................-->
    <!-- CONSULTANT PAGE END -->
    <!--.....................-->


    <!--....................-->
    <!-- STUDENT PAGE START -->
    <!--....................-->
    <div v-if="isActiveTab(1)">
      <h3 class="text-center mb-5">{{ $t('message.careerStudent.thesis') }}</h3>
      <div class="row justify-content-center mx-auto">
        <div class="col-9 col-sm-6 col-md-5 col-lg-4">
          <img class="img-fluid mx-auto polygon-1 pb-3" style="width:100%" src='/static/images/kerstin_working.jpg'>
          <div class="exjobb-below-picture">
            <h4>{{ $t('message.careerStudent.how') }}</h4>
            <p>{{ $t('message.careerStudent.howAnswerThesis1') }}</p>
            <div class="media my-3">
              <a href="mailto:student@precisit.se">
                <img src='/static/images/icon_mail.svg' class="mr-2 icon-sm" alt="Contact e-mail addresses">
              </a>
              <div class="media-body align-self-center">
                <p class="mb-0">{{ $t('message.contact.emailStudent') }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-9 col-sm-6 col-md-5 col-lg-4">
          <h4 >{{ $t('message.careerStudent.who') }}</h4>
          <p>{{ $t('message.careerStudent.whoAnswerThesis1') }}</p>
          <p>{{ $t('message.careerStudent.whoAnswerThesis2') }}</p>

          <div class="exjobb-to-side-of-picture">
            <h4 >{{ $t('message.careerStudent.how') }}</h4>
            <p>{{ $t('message.careerStudent.howAnswerThesis1') }}</p>
            <div class="media my-3">
              <a href="mailto:student@precisit.se">
                <img src='/static/images/icon_mail.svg' class="mr-2 icon-sm" alt="Contact e-mail addresses">
              </a>
              <div class="media-body align-self-center">
                <p class="mb-0">{{ $t('message.contact.emailStudent') }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <h3 class="text-center pt-5 my-5">{{ $t('message.careerStudent.summerJob') }}</h3>
      <div class="row justify-content-center mx-auto">
        <div class="col-9 col-sm-6 col-md-5 col-lg-4">
          <h4 >{{ $t('message.careerStudent.who') }}</h4>
          <p>{{ $t('message.careerStudent.whoAnswerSummer1') }}</p>
          <p>{{ $t('message.careerStudent.whoAnswerSummer2') }}</p>

          <h4 >{{ $t('message.careerStudent.what') }}</h4>
          <p>{{ $t('message.careerStudent.whatAnswer') }}</p>
        </div>
        <div class="col-9 col-sm-6 col-md-5 col-lg-4">
          <img class="img-fluid mx-auto polygon-2 pb-3" style="width:100%" src='/static/images/emma_titti_happy.jpg'>
          <h4 >{{ $t('message.careerStudent.how') }}</h4>
          <!--
            NOTE: DET FINNS TRE OLIKA TEXTER ATT VÄLJA MELLAN:
            applicationClosed, applicationSoon eller applicationOpen.
            VÄLJ EN, BEROENDE PÅ VAR I PROCESSEN VI BEFINNER OSS
          -->
          <p>{{ $t('message.careerStudent.applicationOpen6') }}</p>
          <!--
          <p>{{ $t('message.careerStudent.applicationSoon') }}</p>
          -->
          <!--
          <p>{{ $t('message.careerStudent.applicationOpen1') }}</p>
          <p>{{ $t('message.careerStudent.applicationOpen2') }}</p>
          <p>{{ $t('message.careerStudent.applicationOpen3') }}</p>
          <p>{{ $t('message.careerStudent.applicationOpen4') }}</p>
          <p>{{ $t('message.careerStudent.applicationOpen5') }}</p>
          -->
        </div>
      </div>

  <div class="row justify-content-center my-5">
    <div class="d-none d-sm-inline col-md-12 col-lg-10">
      <div id="carouselExampleIndicators" class="carousel slide" data-ride="carousel" data-interval="false">
        <ol class="carousel-indicators">
          <li data-target="#carouselExampleIndicators" data-slide-to="0" class="active"></li>
          <li data-target="#carouselExampleIndicators" data-slide-to="1"></li>
          <li data-target="#carouselExampleIndicators" data-slide-to="2"></li>
          <li data-target="#carouselExampleIndicators" data-slide-to="3"></li>
          <li data-target="#carouselExampleIndicators" data-slide-to="4"></li>
        </ol>

        <div class="carousel-inner">
          <div class="carousel-item active">
            <div class="media carousel-content responsive-content">
              <div class="media-body">
                <h4>{{ $t('message.carousel.slide1') }}</h4>
                <p>{{ $t('message.carousel.slide1txt1') }}</p>
                <p>{{ $t('message.carousel.slide1txt2') }}</p>
                <p>{{ $t('message.carousel.slide1txt3') }}</p>
              </div>
              <a href="https://custodiansofspace.com/" target="_blank">
                <img class="w-100" src="/static/images/custodians_of_space.png" alt="Custodians of Space image">
              </a>
            </div>
          </div>
          <div class="carousel-item">
            <div class="media carousel-content responsive-content">
              <div class="media-body">
                <h4>{{ $t('message.carousel.slide2') }}</h4>
                <p>{{ $t('message.carousel.slide2txt1') }}</p>
                <p>{{ $t('message.carousel.slide2txt2') }}</p>
              </div>
              <img src="/static/images/slider_photos/exjobb_kerstin_slider.png" alt="Kerstin explaining a concept">
            </div>
          </div>
          <div class="carousel-item">
            <div class="media carousel-content responsive-content">
              <div class="media-body">
                <h4>{{ $t('message.carousel.slide3') }}</h4>
                <p>{{ $t('message.carousel.slide3txt1') }}</p>
                <p>{{ $t('message.carousel.slide3txt2') }}</p>
              </div>
              <img src="/static/images/slider_photos/exjobb_siri_slider.png" alt="Siri focusing on her work">
            </div>
          </div>
          <div class="carousel-item">
            <div class="media carousel-content responsive-content">
              <div class="media-body">
                <h4>{{ $t('message.carousel.slide4') }}</h4>
                <p>{{ $t('message.carousel.slide4txt1') }}</p>
                <p>{{ $t('message.carousel.slide4txt2') }}</p>
              </div>
              <a href="https://tinycosmogame.com/" target="_blank">
                <img class="w-100" src="/static/images/slider_photos/tiny_cosmo.png" alt="Tiny Cosmo image">
              </a>
            </div>
          </div>
          <div class="carousel-item">
            <div class="media carousel-content responsive-content">
              <div class="media-body">
                <h4>{{ $t('message.carousel.slide5') }}</h4>
                <p>{{ $t('message.carousel.slide5txt1') }}</p>
                <p>{{ $t('message.carousel.slide5txt2') }}</p>
                <p>{{ $t('message.carousel.slide5txt3') }}</p>
              </div>
              <img src="/static/images/slider_photos/exjobb_sara_slider.png" alt="Sara looking up from her work">
            </div>
          </div>
        </div>

        <a class="carousel-control-prev" href="#carouselExampleIndicators" role="button" data-slide="prev">
          <span class="carousel-control-prev-icon" aria-hidden="true"></span>
          <span class="sr-only">{{ $t('message.carousel.prev') }}</span>
        </a>
        <a class="carousel-control-next" href="#carouselExampleIndicators" role="button" data-slide="next">
          <span class="carousel-control-next-icon" aria-hidden="true"></span>
          <span class="sr-only">{{ $t('message.carousel.next') }}</span>
        </a>
      </div>
    </div>
  </div>

      <!-- picture -->
      <div class="row photo-section-student pt-5">
        <div class="row my-5 py-5">
        </div>
      </div>
    </div>
    <!--..................-->
    <!-- STUDENT PAGE END -->
    <!--..................-->
    <page-footer></page-footer>
  </div>
</template>

<script>
import PageHero from '@/components/shared/PageHero';
import PageFooter from '../shared/PageFooter';

export default {
  name: 'careerConsultant',
  components: {
    PageFooter,
    PageHero,
  },
  data() {
    return {
      title: 'Career page',
      activeTab: 0,
    };
  },
  methods: {
    isActiveTab(id) {
      return this.activeTab === id;
    },
    // eslint-disable-next-line
    scroll_first_section: function () {
      window.scroll({ top: 650, left: 0, behavior: 'smooth' });
    },
  },
};

</script>

<style lang="scss" scoped>
@import '../../assets/styles/_variables.scss';
@import '../../assets/styles/_shared.scss';
@import '../../assets/styles/_slanted.scss';
$picture-height: 100vh;

.center-image {
  display: flex;
  justify-content: center;
}

.rounded-image-responsive {
  height: 280px;
  width: 280px;
  border-radius: 50%;
  object-fit:cover;

  @include media-breakpoint-down(xl) {
   height: 330px;
  width: 330px;
  }

  @include media-breakpoint-down(lg) {
   height: 280px;
  width: 280px;
  }
   @include media-breakpoint-down(sm) {
   height: 200px;
  width: 200px;
  }
}

.blue-background {
  background-color: $dark-blue;
  p, h3, h4, li {
    color: $white-text;
  }
  li {
  border: 0;
  padding-top: 0;
  padding-bottom: 0;
  background-color: $dark-blue;
  font-size: 22px;
  }
  ul {
    border-left: 2px solid #d0d0d0;
    margin-left: 50px;
  }
}

#moon {
  top: -30%;
  position: relative;

  @include media-breakpoint-down(md) {
    top: 0;
  }

  img {
    width: 280px;
    @include media-breakpoint-down(md) {
     width: 230px;
    }
    @include media-breakpoint-down(sm) {
     width: 180px;
    }
  }
}

h5,h3 {
    color: $medium-blue;
}

.slanted-container-left {
  @include slanted-container-left(white, $dark-blue, 0);
}

.slanted-container-right {
  @include slanted-container-right(white, $dark-blue, 0);
}

.page-selector {
 margin-top: -60px;  //conteract the padding from pagehero

  .clickable {
    cursor: pointer;
    font-size: 22px;

    &:hover {
    text-decoration: none;
    }
  }

  .is-active:after {
    content: "";
    display: block;
    margin: 0 auto;
    width: 50%;
    border-bottom: 1px solid $medium-blue;
  }
}

.card-body {
  padding-top: 1.3rem;
}

.astronaut-icon {
  width: 400px;
   @include media-breakpoint-down(md) {
     width: 350px;
    }
}

.photo-section-student {
  @include footer-banner('/static/images/kerstin_siri_working.jpg');
}

.photo-section-consultant {
  @include footer-banner('/static/images/new_space_mountains_4k.jpg');
}

.polygon-1 {
  -webkit-clip-path: polygon(0 18%, 100% 0, 100% 100%, 6% 100%);
  clip-path: polygon(0 18%, 100% 0, 100% 100%, 6% 100%);
}

.polygon-2 {
  -webkit-clip-path: polygon(0 0, 100% 18%, 94% 100%, 0 100%);
  clip-path: polygon(0 0, 100% 18%, 94% 100%, 0 100%);
}

.icon-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 85px;
  width: 100px;
  margin: auto;
  img {
    height: 100%;
  }
}

.icon-container.icon-smaller {
  img {
    height: 85%;
  }
}

.icon-sm {
  width: 34px;
}
.icon-sm:hover {
  transform: scale(1.2);
}

.carousel-control-prev-icon {
    background-image: url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='%23E36C6C' "+
    "viewBox='0 0 8 8'%3E%3Cpath d='M5.25 0l-4 4 4 4 1.5-1.5-2.5-2.5 2.5-2.5-1.5-1.5z'/%3E%3C/svg%3E");
}

.carousel-control-next-icon {
    background-image: url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='%23E36C6C' "+
    "viewBox='0 0 8 8'%3E%3Cpath d='M2.75 0l-1.5 1.5 2.5 2.5-2.5 2.5 1.5 1.5 4-4-4-4z'/%3E%3C/svg%3E");
}

.carousel-indicators {
  li {
    // Styling for inactive indicators
    background-color: $white-text;
  }
  .active {
    // Styling for active indicator
    background-color: $scroll-icon;
  }
}

.carousel-content {
  margin: 5% 10%;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 75vh;
  @include media-breakpoint-up(md) {
    height: 60vh;
  }
  @include media-breakpoint-up(lg) {
    height: 65vh;
  }
  @include media-breakpoint-up(xl) {
    height: 45vh;
  }
  p, h4 {
    padding: 0 20px;

  }
}

.horizontal-texts {
  width: 100%;
  display: flex;
  p {
    width: 50%;
  }
}

.horizontal-image {
  width: 100%;
  height: 164px;
  display: flex;
  justify-content: center;

  img {
    overflow: hidden;
    width: 528px;
    height: 150px;
  }
}

.responsive-content {
  .media-body {
    @include media-breakpoint-down(sm) {
      width: 65%;
    }
    p {
      @include media-breakpoint-down(sm) {
        font-size: 14px;
      }
    }
  }

  img, a {
    width: 25%;
    @include media-breakpoint-down(sm) {
      width: 35%;
    }
    overflow: hidden;
  }
}

@media (max-width: 1140px) {
  .sommarjobb-below-picture {
    display: block;
  }

  .sommarjobb-to-side-of-picture {
    display: none;
  }
}

.exjobb-below-picture {
    display: none;
}

.exjobb-to-side-of-picture {
    display: block;
}

@media (max-width: 660px) {
  .exjobb-below-picture {
    display: block;
  }

  .exjobb-to-side-of-picture {
    display: none;
  }
}

</style>
